"use client";

import { motion, useReducedMotion } from "framer-motion";
const milestones = [{
  year: "2022",
  title: "The Vision",
  description: "Victoria Light Foundation begins as a grassroots initiative. The core mission of spreading love and light through community support takes root."
}, {
  year: "2022",
  title: "First Outreach",
  description: "Our initial outreach program launches, providing essential resources to local families. We establish our commitment to making the world a better place."
}, {
  year: "2023",
  title: "Community Growth",
  description: "Membership expands as we host our first series of community workshops. We welcome our first hundred active members to the foundation."
}, {
  year: "2023",
  title: "Expanded Impact",
  description: "We partner with local organizations to broaden our reach. Our programs now serve three distinct neighborhoods with dedicated support teams."
}, {
  year: "2024",
  title: "Quarterly Membership",
  description: "We introduce the 3rd quarter membership portal, streamlining how our community connects and contributes to our shared goals."
}, {
  year: "2024",
  title: "Future Vision",
  description: "Victoria Light Foundation marks two years of service. We continue to refine our approach, driven by our motto: love and light."
}];
export default function Journey() {
  const prefersReducedMotion = useReducedMotion();
  return;
}